import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { IronLogicOperationEnum } from '@zaoblako/shared/modules/pacs/enums/iron-logic-operation.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link IronLogicOperationEnum} enumeration values */
export const IronLogicOperationEnumI18n: EnumI18nInterface<IronLogicOperationEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [IronLogicOperationEnum.POWER_ON]: 'Запрос от конвертера: попытка подключения',
    [IronLogicOperationEnum.CHECK_ACCESS]: 'Запрос от конвертера: проверить карту доступа',
    [IronLogicOperationEnum.PING]: 'Запрос от конвертера: пинг сервера (запрос команд с сервера)',
    [IronLogicOperationEnum.EVENTS]: 'Запрос от конвертера: события',
    [IronLogicOperationEnum.SET_ACTIVE]: 'Команда от сервера: активировать соединение с конвертером',
    [IronLogicOperationEnum.OPEN_DOOR]: 'Команда от сервера: открыть дверь',
    [IronLogicOperationEnum.SET_MODE]: 'Команда от сервера: установить режим работы',
    [IronLogicOperationEnum.SET_TIMEZONE]: 'Команда от сервера: установить расписание работы',
    [IronLogicOperationEnum.SET_DOOR_PARAMS]: 'Команда от сервера: задать настройки двери',
    [IronLogicOperationEnum.ADD_CARDS]: 'Команда от сервера: добавить карты доступа',
    [IronLogicOperationEnum.ADD_CARDS_CONCRETE]: 'Команда от сервера: добавить конкретные карты доступа',
    [IronLogicOperationEnum.DEL_CARDS]: 'Команда от сервера: удалить конкретные карты доступа',
    [IronLogicOperationEnum.CLEAR_CARDS]: 'Команда от сервера: удалить все карты доступа',
    [IronLogicOperationEnum.READ_CARDS]: 'Команда от сервера: загрузить все карты доступа с конвертера',
  },
  [I18nLocalesEnum.EN_US]: {
    [IronLogicOperationEnum.POWER_ON]: 'Request from converter: connection attempt',
    [IronLogicOperationEnum.CHECK_ACCESS]: 'Request from converter: check access card',
    [IronLogicOperationEnum.PING]: 'Request from converter: ping server (request server commands)',
    [IronLogicOperationEnum.EVENTS]: 'Request from converter: events',
    [IronLogicOperationEnum.SET_ACTIVE]: 'Server command: activate converter connection',
    [IronLogicOperationEnum.OPEN_DOOR]: 'Server command: open door',
    [IronLogicOperationEnum.SET_MODE]: 'Server command: set door mode',
    [IronLogicOperationEnum.SET_TIMEZONE]: 'Server command: set door schedule',
    [IronLogicOperationEnum.SET_DOOR_PARAMS]: 'Server command: set door settings',
    [IronLogicOperationEnum.ADD_CARDS]: 'Server command: add access cards',
    [IronLogicOperationEnum.ADD_CARDS_CONCRETE]: 'Server command: add concrete access cards',
    [IronLogicOperationEnum.DEL_CARDS]: 'Server command: remove concrete access cards',
    [IronLogicOperationEnum.CLEAR_CARDS]: 'Server command: remove all access cards',
    [IronLogicOperationEnum.READ_CARDS]: 'Server command: load all access cards from converter',
  },
};
